import { apiServicesSlice } from "@/redux/app/api/apiSlice";

export const servicesSlice = apiServicesSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllServices: builder.query({
      query: (params) => ({
        url: `/api/dashboard/service`,
        params: { ...params },
      }),
      providesTags: ["Services"],
    }),
    getSpecificService: builder.query({
      query: (serviceId) => ({
        url: `/api/dashboard/service/${serviceId}`,
      }),
      providesTags: ["Services"],
    }),
    createServices: builder.mutation({
      query: (serviceItem) => ({
        url: "/api/dashboard/service",
        method: "POST",
        body: serviceItem,
      }),
      invalidatesTags: ["Services"],
    }),
    updateServices: builder.mutation({
      query: ({ serviceId, serviceItem }) => ({
        url: `/api/dashboard/service/${serviceId}`,
        method: "POST",
        body: serviceItem,
        // extraOptions: { skipToast: true }, // disable deafult toast
      }),
      invalidatesTags: ["Services"],
    }),
    deleteServices: builder.mutation({
      query: (serviceId) => ({
        url: `/api/dashboard/service/${serviceId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Services"],
    }),
  }),
});

export const {
  useGetAllServicesQuery,
  useLazyGetAllServicesQuery,
  useGetSpecificServiceQuery,
  useCreateServicesMutation,
  useUpdateServicesMutation,
  useDeleteServicesMutation,
} = servicesSlice;
